import { useEffect, useState } from 'react';
import { readCookie } from './readCookie';
import { writeCookie, WriteCookieOptions } from './writeCookie';

export const useCookie = (
  name: string
): [string, (newValue: string, options: WriteCookieOptions) => void] => {
  const [value, setValue] = useState('');

  useEffect(() => {
    // Cookie reading is deferred until after the component mounts
    setValue(readCookie(name));
  }, [name]);

  const setCookie = (newValue: string, options: WriteCookieOptions) => {
    writeCookie(name, newValue, options);
    setValue(newValue);
  };

  return [value, setCookie];
};
